import Size from '@enums/Size';

/**
 * Returns style properties for input fields based on the size.
 * @param {String} size
 * @return {Object}
 */
export default function inputSizeProps(size) {
  const sizeProps = {
    fontSize: '0.875rem',
    fontWeight: 500,
    height: '1.75rem',
    lineHeight: '1.75rem',
  };

  switch (size) {
    case Size.SMALL:
      sizeProps.fontSize = '0.825rem';
      sizeProps.height = '1.75rem';
      sizeProps.lineHeight = '1.75rem';
      return sizeProps;
    case Size.LARGE:
      sizeProps.fontSize = '0.95rem';
      sizeProps.fontWeight = 400;
      sizeProps.height = '1.75rem';
      sizeProps.lineHeight = '1.75rem';
      return sizeProps;
    case Size.X_LARGE:
      sizeProps.fontSize = '1rem';
      sizeProps.height = '2rem';
      sizeProps.lineHeight = '2rem';
      return sizeProps;
    default:
      return sizeProps;
  }
}
